/* components/Radio.svelte generated by Svelte v3.23.2 */
import {
	SvelteComponent,
	append,
	attr,
	create_slot,
	detach,
	element,
	init,
	insert,
	listen,
	safe_not_equal,
	space,
	toggle_class,
	transition_in,
	transition_out,
	update_slot
} from "svelte/internal";

function add_css() {
	var style = element("style");
	style.id = "svelte-4h3rom-style";
	style.textContent = "label.svelte-4h3rom.svelte-4h3rom{display:flex;align-items:center;margin-top:24px}label.svelte-4h3rom.svelte-4h3rom:first-child{margin-top:0}input.svelte-4h3rom.svelte-4h3rom{display:none}.radio.svelte-4h3rom.svelte-4h3rom{display:block;width:20px;height:20px;border:1px solid #29ABE2;border-radius:50%;margin-right:28px;position:relative;box-sizing:border-box}.radio.svelte-4h3rom.svelte-4h3rom::before{content:'';position:absolute;z-index:1;width:8px;height:8px;left:5px;top:5px;border-radius:50%;background:#29ABE2;box-shadow:0 0 8px #29ABE2;opacity:0;transition:opacity .3s}.label-text.svelte-4h3rom.svelte-4h3rom{transition:color .3s}.active.svelte-4h3rom .label-text.svelte-4h3rom{color:#29ABE2}.active.svelte-4h3rom .radio.svelte-4h3rom::before{opacity:1}label.svelte-4h3rom:not(.active):active .radio.svelte-4h3rom::before{opacity:0.4}label.svelte-4h3rom:active .label-text.svelte-4h3rom{color:#29ABE2}@media(min-width: 768px){label.svelte-4h3rom.svelte-4h3rom{margin-top:20px}}@media(hover: hover){label.svelte-4h3rom.svelte-4h3rom:hover{cursor:pointer}label.svelte-4h3rom:not(.active):hover .radio.svelte-4h3rom::before{opacity:0.4}label.svelte-4h3rom:hover .label-text.svelte-4h3rom{color:#29ABE2}}";
	append(document.head, style);
}

function create_fragment(ctx) {
	let label;
	let input;
	let t0;
	let span0;
	let t1;
	let span1;
	let current;
	let mounted;
	let dispose;
	const default_slot_template = /*$$slots*/ ctx[3].default;
	const default_slot = create_slot(default_slot_template, ctx, /*$$scope*/ ctx[2], null);

	return {
		c() {
			label = element("label");
			input = element("input");
			t0 = space();
			span0 = element("span");
			t1 = space();
			span1 = element("span");
			if (default_slot) default_slot.c();
			attr(input, "type", "radio");
			input.__value = /*value*/ ctx[1];
			input.value = input.__value;
			attr(input, "class", "svelte-4h3rom");
			/*$$binding_groups*/ ctx[5][0].push(input);
			attr(span0, "class", "radio svelte-4h3rom");
			attr(span1, "class", "label-text svelte-4h3rom");
			attr(label, "class", "svelte-4h3rom");
			toggle_class(label, "active", /*value*/ ctx[1] === /*group*/ ctx[0]);
		},
		m(target, anchor) {
			insert(target, label, anchor);
			append(label, input);
			input.checked = input.__value === /*group*/ ctx[0];
			append(label, t0);
			append(label, span0);
			append(label, t1);
			append(label, span1);

			if (default_slot) {
				default_slot.m(span1, null);
			}

			current = true;

			if (!mounted) {
				dispose = listen(input, "change", /*input_change_handler*/ ctx[4]);
				mounted = true;
			}
		},
		p(ctx, [dirty]) {
			if (!current || dirty & /*value*/ 2) {
				input.__value = /*value*/ ctx[1];
			}

			input.value = input.__value;

			if (dirty & /*group*/ 1) {
				input.checked = input.__value === /*group*/ ctx[0];
			}

			if (default_slot) {
				if (default_slot.p && dirty & /*$$scope*/ 4) {
					update_slot(default_slot, default_slot_template, ctx, /*$$scope*/ ctx[2], dirty, null, null);
				}
			}

			if (dirty & /*value, group*/ 3) {
				toggle_class(label, "active", /*value*/ ctx[1] === /*group*/ ctx[0]);
			}
		},
		i(local) {
			if (current) return;
			transition_in(default_slot, local);
			current = true;
		},
		o(local) {
			transition_out(default_slot, local);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(label);
			/*$$binding_groups*/ ctx[5][0].splice(/*$$binding_groups*/ ctx[5][0].indexOf(input), 1);
			if (default_slot) default_slot.d(detaching);
			mounted = false;
			dispose();
		}
	};
}

function instance($$self, $$props, $$invalidate) {
	let { group = undefined } = $$props;
	let { value = undefined } = $$props;
	let { $$slots = {}, $$scope } = $$props;
	const $$binding_groups = [[]];

	function input_change_handler() {
		group = this.__value;
		$$invalidate(0, group);
	}

	$$self.$set = $$props => {
		if ("group" in $$props) $$invalidate(0, group = $$props.group);
		if ("value" in $$props) $$invalidate(1, value = $$props.value);
		if ("$$scope" in $$props) $$invalidate(2, $$scope = $$props.$$scope);
	};

	return [group, value, $$scope, $$slots, input_change_handler, $$binding_groups];
}

class Radio extends SvelteComponent {
	constructor(options) {
		super();
		if (!document.getElementById("svelte-4h3rom-style")) add_css();
		init(this, options, instance, create_fragment, safe_not_equal, { group: 0, value: 1 });
	}
}

export default Radio;